import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import _get from 'lodash/get';
import ProfileStore from '../../../../stores/ProfileStore';
import NotificationStore from '../../../../stores/NotificationStore';
import { i18nextInstance } from '../../../../../i18n';
import { GENDERS } from '../../../../framework/constants/profile';
import { PHONE_PREFIXES, PHONE_PREFIX_DEFAULT } from 'framework/constants/forms';
const interceptor = {
    key: 'default',
    call: ({ change }) => {
        if (change.newValue !== null && change.newValue !== undefined) {
            return change;
        }
        change.newValue = '';
        return change;
    }
};
const createDropDownInterceptor = (values) => ({
    key: 'default',
    call: ({ change }) => {
        const value = values.find(({ value }) => value === change.newValue);
        change.newValue = value !== undefined ? value : '';
        return change;
    }
});
export const fields = [
    {
        name: 'gender',
        label: 'modals:offerRequest.gender',
        placeholder: 'modals:offerRequest.genderPlaceholder',
        rules: 'required',
        extra: GENDERS,
        interceptors: [createDropDownInterceptor(GENDERS)]
    },
    {
        name: 'firstName',
        label: 'CheckoutPage:contactInformation:fieldLabels.firstName',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'lastName',
        label: 'CheckoutPage:contactInformation:fieldLabels.lastName',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'phoneMain',
        label: 'CheckoutPage:contactInformation:fieldLabels.countryCode',
        fields: [
            {
                name: 'countryCode',
                label: 'CheckoutPage:contactInformation:fieldLabels.countryCode',
                type: 'string',
                rules: 'required',
                value: PHONE_PREFIX_DEFAULT,
                extra: PHONE_PREFIXES,
                observers: [{
                        key: 'value',
                        call: ({ form, change: { oldValue, newValue } }) => {
                            const regExp = /^(\+?\d{1,3}|\d{1,4})$/.test(newValue);
                            if (regExp || newValue === '+' || newValue === '') {
                                form.container().$('phoneMain.countryCode').set('value', newValue);
                            }
                            else {
                                form.container().$('phoneMain.countryCode').set('value', oldValue);
                            }
                        }
                    }],
                output: (data) => {
                    return data.value ? data.value : data;
                }
            },
            {
                name: 'areaCode',
                label: 'CheckoutPage:contactInformation:fieldLabels.areaCode',
                type: 'number',
                rules: 'required|phone_areaCode',
                value: ''
            },
            {
                name: 'phoneNumber',
                label: 'CheckoutPage:contactInformation:fieldLabels.phoneNumber',
                type: 'number',
                rules: 'required|phone_phoneNumber',
                value: ''
            }
        ],
        output: (value) => {
            const { countryCode, areaCode, phoneNumber } = value;
            return `${countryCode ? countryCode : ''}${areaCode}${phoneNumber}`;
        },
        interceptors: [{
                key: 'default',
                call: ({ field, change }) => {
                    if (change.newValue) {
                        const countryCode = field.$('countryCode');
                        const areaCode = field.$('areaCode');
                        const phoneNumber = field.$('phoneNumber');
                        countryCode.set('rules', '');
                        countryCode.set('default', '');
                        areaCode.set('rules', '');
                        areaCode.set('default', '');
                        phoneNumber.set('rules', 'required|phone');
                        phoneNumber.set('default', change.newValue);
                    }
                    return null;
                }
            }]
    }
];
const hooks = {
    onSuccess: (form) => {
        const { ...userAddress } = form.values();
        return ProfileStore.updateUserProfileBaseInfo({ userAddress })
            .then(() => ProfileStore.getProfileData())
            .catch((reason) => {
            const { errors } = reason;
            if (Array.isArray(errors)) {
                errors.forEach((error) => {
                    if (error.status === '500') {
                        NotificationStore.addNotification({
                            message: i18nextInstance.t('modals:offerRequest.saveDataFailed'),
                            level: 'error'
                        });
                        return;
                    }
                    const pointer = _get(error, 'source.pointer', '').split('/');
                    const fieldName = pointer.length ? pointer[pointer.length - 1] : '';
                    const errorDetail = _get(error, 'detail', '');
                    if (form.has(fieldName)) {
                        NotificationStore.addNotification({
                            message: `Error in field "${fieldName}": ${errorDetail}`,
                            level: 'error'
                        });
                        const field = form.$(fieldName);
                        if (field.hasNestedFields) {
                            field.each((field) => {
                                field.invalidate();
                            });
                        }
                        else {
                            field.invalidate(errorDetail);
                        }
                    }
                });
            }
            throw reason;
        });
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    showErrorsOnReset: false,
    validateOnBlur: true,
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
